import { useState } from "react";

import { observer } from "mobx-react-lite";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";

import iLogout from "../../../assets/images/100-logout.svg";
import iSetting from "../../../assets/images/100-setting.svg";
import iUpgrade from "../../../assets/images/100-upgrade.svg";
import User_profile from "../../../assets/images/avatar1.png";
import organizationLogo from "../../../assets/images/company_logo.png";
import { useLiveWorkspaceCreationContext } from "../../../contexts/LiveWorkspaceCreationContext";
import { useAuth } from "../../../contexts/authContext";
import { useMeetingDetailsStore } from "../../../contexts/meetingDetails/meetingDetailsContext";
import { useApi } from "../../../hooks/useApi";

const UserPanel = () => {
  const contextStore = useMeetingDetailsStore();
  const location = useLocation();
  const history = useHistory();
  const { createMeeting } = useApi();
  const { selectedCourses, workspaceTitle, workspaceDesc, creating, setCreating } = useLiveWorkspaceCreationContext();
  const { logout } = useApi();
  const { userData, loggedOut } = useAuth();
  const [openProfileDropdown, setOpenProfileDropdown] = useState(false);

  const handleSignOut = () => {
    logout().then((res) => {
      if (res.msg === "access revoked") loggedOut();
    });
  };

  const canCreate = selectedCourses[0] && workspaceTitle;
  const handleCreate = async (e) => {
    e.preventDefault();
    if (!selectedCourses[0] || !workspaceTitle) return;
    window.scrollTo({ top: 0, behavior: "smooth" });
    setCreating(true);
    contextStore.clearPersistedData();
    contextStore.reset();
    const { mid } = await createMeeting({
      cid: selectedCourses[0].cid,
      title: workspaceTitle,
      desc: workspaceDesc,
      // startsAt: new Date(....),
      duration: 60,
    });

    history.push(`/live/${mid}`);
    // No need to reset form data (states) since we will navigate away and this component will be unmounted
  };

  if (location.pathname.includes("/create")) {
    if (creating) {
      return (
        <div className="line-progress-bar">
          <span className="line-loading" />
        </div>
      );
    }
    return (
      <div className="align-items-center flex-row-reverse">
        <div className="flex align-items-center">
          <NavLink to="/live" className="button button-lg button-r button-gr m-r-24">
            <span>Cancel</span>
          </NavLink>
          <button type="button" onClick={handleCreate} className={`button button-lg button-r button-bk ${!canCreate ? "disable" : ""}`}>
            <span>Create Live Workspace</span>
          </button>
        </div>
      </div>
    );
  }
  return (
    <>
      <div>
        <img alt="Organization logo" src={organizationLogo} width={125} height={52} className="m-r-16 m-l-32" id="organizationLogo" />
        <img
          alt=""
          src={User_profile}
          width={52}
          height={52}
          className="pointer"
          id="user-profile"
          onClick={() => setOpenProfileDropdown(!openProfileDropdown)}
        />
      </div>
      {openProfileDropdown && (
        <div className="dropdown-profile" onClick={() => setOpenProfileDropdown(!openProfileDropdown)}>
          <div className="space-between p-lr-16 m-tb-12">
            <div className="w-142 three-dot">
              <div className="font-14">
                {userData.first_name} {userData.last_name}
              </div>
              <div className="font-10">{userData.email}</div>
              <div className="font-10">{userData?.org?.name}</div>
            </div>
            <img alt="" src={User_profile} width={52} height={52} />
          </div>
          <div className="dropdown-list-items">
            <Link to="/settings">
              <img alt="" src={iSetting} className="i-setting" />
              <span>Settings</span>
            </Link>
            <Link to="/">
              <img alt="" src={iUpgrade} className="i-upgrade" />
              <span>Upgrade</span>
            </Link>
            <button className="text-red2" onClick={handleSignOut}>
              <img alt="" src={iLogout} className="i-logout" />
              <span>Log out</span>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default observer(UserPanel);
